import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PatientProvider } from './contexts/PatientContext';

import SplashScreen from './screens/SplashScreen';
import LoginScreen from './screens/LoginScreen';
import SignupScreen from './screens/SignupScreen';
import { ForgotPasswordScreen, ResetPasswordScreen } from './screens/PasswordScreens';
import DashboardScreen from './screens/DashboardScreen';
import PatientScreen from './screens/PatientScreen';
import NewAnalysisScreen from './screens/NewAnalysisScreen';
import ResultScreen from './screens/ResultScreen';
import HistoryScreen from './screens/HistoryScreen';


import { ShareResultScreen, ShareHistoryScreen } from './screens/ShareScreens';
import AccountScreen from './screens/AccountScreen';
import AboutScreen from './screens/AboutScreen';
import ContactScreen from './screens/ContactScreen';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  return !user ? children : <Navigate to="/dashboard" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<SplashScreen />} />
      <Route path="/login" element={<PublicRoute><LoginScreen /></PublicRoute>} />
      <Route path="/signup" element={<PublicRoute><SignupScreen /></PublicRoute>} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />
      <Route path="/reset-password" element={<ResetPasswordScreen />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardScreen /></ProtectedRoute>} />
      <Route path="/patient" element={<ProtectedRoute><PatientScreen /></ProtectedRoute>} />
      <Route path="/new-analysis" element={<ProtectedRoute><NewAnalysisScreen /></ProtectedRoute>} />
      <Route path="/result" element={<ProtectedRoute><ResultScreen /></ProtectedRoute>} />
      <Route path="/history" element={<ProtectedRoute><HistoryScreen /></ProtectedRoute>} />
      <Route path="/share-result" element={<ProtectedRoute><ShareResultScreen /></ProtectedRoute>} />
      <Route path="/share-history" element={<ProtectedRoute><ShareHistoryScreen /></ProtectedRoute>} />
      <Route path="/account" element={<ProtectedRoute><AccountScreen /></ProtectedRoute>} />
      <Route path="/about" element={<ProtectedRoute><AboutScreen /></ProtectedRoute>} />
      <Route path="/contact" element={<ProtectedRoute><ContactScreen /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PatientProvider>
          <AppRoutes />
        </PatientProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
